<header class="main_content">
  <div class="content">
    <div class="input_container">
      <input
        #searchInput
        class="search_input"
        type="text"
        autocomplete="off"
        [placeholder]="'VEHICLES.SEARCH.GENERAL' | translate"
        (input)="onSearchInput($event)"
      />
      <i
        *ngIf="isSelectedInputSearch"
        class="fa fa-close icon_search"
        aria-hidden="true"
        (click)="onClickClearInput(searchInput)"
      ></i>
    </div>
    <div class="buttons_container">
      <button
        *ngIf="vehicleConfigService.configuration.panel.btnCreateGroup"
        class="btn-v1"
        [title]="'VEHICLES.ACTION.ADD_ENTITY' | translate"
        data-bs-toggle="tooltip"
        data-bs-placement="auto"
        (click)="onClickGroup()"
        onclick="this.blur()"
      >
        <i class="fa fa-plus"></i>
      </button>
      <div
        *ngIf="vehicleConfigService.configuration.panel.btnCustomPanel"
        ngbDropdown
        container="body"
        placement="right-top left-top"
        class="flex-none"
      >
        <button
          ngbDropdownToggle
          class="btn-v2"
          [title]="'VEHICLES.ACTION.CUSTOMIZE' | translate"
        >
          <i class="fa fa-fw fa-bars fa-1"></i>
        </button>
        <div
          ngbDropdownMenu
          class="gl-custom-dropdown dropdown-customize-vehicle-panel disable-chkbox-behavior"
        >
          <div class="text-center">
            {{ "VEHICLES.CUSTOMIZATION.TITLE" | translate }}
          </div>
          <div class="container pt-2 png-checkbox-container">
            <div class="button-group" *ngIf="showVehicleButtonOptions">
              <p-selectButton
                (click)="onClickSelectButton()"
                [options]="stateOptions"
                [(ngModel)]="valueSelectButton"
                optionLabel="label"
                optionValue="value"
              ></p-selectButton>
            </div>
            <div class="dropdown-divider"></div>
            <!-- <app-item-custom-panel-vehicle
              *ngFor="let item of items"
              [idItem]="item.idItem"
              [variant]="item.variant"
              [labelInput]="{
                on: 'Ocultar IMEI en la tarjeta',
                off: 'Mostrar IMEI en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle> -->

            <app-item-custom-panel-vehicle
              idItem="verImei"
              variant="imei"
              [labelInput]="{
                on: 'Ocultar IMEI en la tarjeta',
                off: 'Mostrar IMEI en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>

            <app-item-custom-panel-vehicle
              idItem="numSim"
              variant="numSim"
              [labelInput]="{
                on: 'Ocultar número SIM en la tarjeta',
                off: 'Mostrar número SIM en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>

            <app-item-custom-panel-vehicle
              idItem="verColor"
              variant="color"
              [labelInput]="{
                on: 'Ocultar estado de transmisión',
                off: 'Mostrar estado de transmisión'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verIgnition"
              variant="ignition"
              [labelInput]="{
                on: 'Ocultar estado de ignición en la tarjeta',
                off: 'Mostrar estado de ignición en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verSpeed"
              variant="speed"
              [labelInput]="{
                on: 'Ocultar velocidad en la tarjeta',
                off: 'Mostrar velocidad en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verBaterryVoltage"
              variant="batteryVoltage"
              [labelInput]="{
                on: 'Ocultar voltaje de batería en la tarjeta',
                off: 'Mostrar voltaje de batería en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verAmountOfFuel"
              variant="amountOfFuel"
              [labelInput]="{
                on: 'Ocultar combustible en la tarjeta',
                off: 'Mostrar combustible en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verTimeElapsed"
              variant="timeElapsed"
              [labelInput]="{
                on: 'Ocultar tiempo transcurrido en la tarjeta',
                off: 'Mostrar tiempo transcurrido en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verSatellite"
              variant="satellite"
              [labelInput]="{
                on: 'Ocultar cantidad de satélites en la tarjeta',
                off: 'Mostrar cantidad de satélites en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              *appHasPermission="'vehicles_options_teltonika'"
              idItem="verTemperaturaBle"
              variant="temperature-ble"
              [labelInput]="{
                on: 'Ocultar la temperatura BLE en la tarjeta',
                off: 'Mostrar la temperatura BLE en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              *appHasPermission="'vehicles_options_teltonika'"
              idItem="verTemperaturaEye"
              variant="temperature-eye"
              [labelInput]="{
                on: 'Ocultar la temperatura EYE en la tarjeta',
                off: 'Mostrar la temperatura EYE en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>

            <app-item-custom-panel-vehicle
              *appHasPermission="'vehicles_options_teltonika'"
              idItem="verHumedadBle"
              variant="humidity-ble"
              [labelInput]="{
                on: 'Ocultar la humedad BLE en la tarjeta',
                off: 'Mostrar la humedad BLE en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              *appHasPermission="'vehicles_options_teltonika'"
              idItem="verHumedadEye"
              variant="humidity-eye"
              [labelInput]="{
                on: 'Ocultar la humedad EYE en la tarjeta',
                off: 'Mostrar la humedad EYE en la tarjeta'
              }"
            >
            </app-item-custom-panel-vehicle>

            <app-item-custom-panel-vehicle
              idItem="verIconVehicle"
              variant="icon"
              [labelInput]="{
                on: 'Ocultar ícono del vehículo',
                off: 'Mostrar ícono del vehículo'
              }"
            >
            </app-item-custom-panel-vehicle>

            <app-item-custom-panel-vehicle
              idItem="verNombreConductor"
              variant="driverName"
              [labelInput]="{
                on: 'Ocultar nombre del conductor',
                off: 'Mostrar nombre del conductor'
              }"
            >
            </app-item-custom-panel-vehicle>

            <app-item-custom-panel-vehicle
              idItem="ver"
              variant="see"
              [labelInput]="{
                on: 'Ocultar control de visualización de puntos de vehículos',
                off: 'Mostrar control de visualización de puntos de vehículos'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verTransmissionStatus"
              variant="transmissionStatus"
              [labelInput]="{
                on: 'Ocultar filtrado por estado de transmisión',
                off: 'Mostrar filtrado por estado de transmisión'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verCommand"
              variant="command"
              [labelInput]="{
                on: 'Ocultar botón de Comando',
                off: 'Mostrar botón de Comando'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verHistory"
              variant="history"
              [labelInput]="{
                on: 'Ocultar botón de historial',
                off: 'Mostrar botón de historial'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verDriver"
              variant="driver"
              [labelInput]="{
                on: 'Ocultar botón de conductor',
                off: 'Mostrar botón de conductor'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verName"
              variant="nameButton"
              [labelInput]="{
                on: 'Ocultar botón de nombre',
                off: 'Mostrar botón de nombre'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verFollowUnit"
              variant="followUnitButton"
              [labelInput]="{
                on: 'Ocultar botón de seguir vehículo',
                off: 'Mostrar botón de seguir vehículo'
              }"
            >
            </app-item-custom-panel-vehicle>
            <app-item-custom-panel-vehicle
              idItem="verEye"
              variant="eye"
              [labelInput]="{
                on: 'Ocultar botón de visualización',
                off: 'Mostrar botón de visualización'
              }"
            >
            </app-item-custom-panel-vehicle>
            <div class="dropdown-divider"></div>
          </div>
          <!-- <div class="dropdown-item active" style="padding: 0.125rem 0.75rem">
                <i
                  class="fas fa-sitemap ag-grid-header-icon text-center"
                  style="width: 20px"
                ></i>
                <span>Vista por Operación</span>
              </div> -->
        </div>
      </div>
    </div>
  </div>
  <div></div>
</header>
